export default function CarsRequestDataFactory(
    moment,
    TimeLocationConstructor,
    l10nService,
    defaultTimeFactory
) {
    'ngInject';

            const timeOptions = defaultTimeFactory.getTimeOptions();
            const formats = defaultTimeFactory.defaultFormats;

            const carsRequestData = {
                isUserOutOfRange: false,
                pickUp: new TimeLocationConstructor(),
                dropOff: new TimeLocationConstructor(),
                defaultTimeOptions: timeOptions,
                countryCode: '',
                administrativeAreaLevel1: '',
                adjustDates,
            };

            carsRequestData.pickUp.date.pickerSettings = {
                placeholder: l10nService.localize('Pick up'),
                required: true,
                months: 2,
                start: moment(),
                after: moment().add({days: -1}),
                dependentPikers: ['dropOffDateSettings'],
                shiftDependentDays: 0,
            };

            carsRequestData.dropOff.date.pickerSettings = {
                placeholder: l10nService.localize('Drop off'),
                required: true,
                months: 2,
                start: moment(),
                after: moment(),
            };

            return carsRequestData;

            function adjustTime(type, setPrevious, minIdx) {
                if (setPrevious) {
                    this[type].time.previous = angular.copy(this[type].time.current);
                    return;
                }

                if (!minIdx) {
                    this[type].time.current = angular.copy(this[type].time.previous || this[type].time.default);
                    return;
                }

                this[type].time.current = angular.copy(this.defaultTimeOptions[minIdx]);

                if (this[type].time.previous) {
                    if (this[type].time.previous.value < this[type].time.current.value) {
                        this[type].time.previous = null;
                    } else {
                        this[type].time.current = angular.copy(this[type].time.previous);
                    }
                }
            }

            function adjustDates(param) {
                const pickUpDate = angular.isDefined(param.pickUpDate)
                        ? param.pickUpDate
                        : moment(this.pickUp.date.value, formats.date);
                const dropOffDate = angular.isDefined(param.dropOffDate)
                        ? param.dropOffDate
                        : moment(this.dropOff.date.value, formats.date);
                const pickUpTime = param.pickUpTime ? param.pickUpTime.value : this.pickUp.time.current.value;
                const dropOffTime = param.dropOffTime ? param.dropOffTime.value : this.dropOff.time.current.value;
                const pickUpDateTime = pickUpDate.add(pickUpTime, 'minutes');
                const pickUpMinIdx = getPickUpMinIdx.call(this, pickUpDateTime);

                let dropOffDateTime = dropOffDate.add(dropOffTime, 'minutes');
                let pickUpMaxIdx;
                let dropOffMinIdx;

                if (pickUpDateTime.isAfter(dropOffDateTime)) {
                    this.dropOff.date.value = dropOffDateTime = null;
                    this.dropOff.time.current = angular.copy(this.dropOff.time.default);
                }

                if (pickUpDateTime.isSame(dropOffDateTime, 'day')) {
                    dropOffMinIdx
                        = getTimeOptionIndexByTime(this.defaultTimeOptions, this.pickUp.time.current.value) + 1;

                    adjustTime.call(this, 'dropOff', !!param.dropOffTime, dropOffMinIdx);
                    pickUpMaxIdx = getTimeOptionIndexByTime(this.defaultTimeOptions, this.dropOff.time.current.value);
                    adjustTime.call(this, 'pickUp', !!param.pickUpTime, pickUpMinIdx);
                } else {
                    dropOffMinIdx = pickUpMaxIdx = undefined;
                    adjustTime.call(this, 'pickUp', !!param.pickUpTime, pickUpMinIdx);
                    adjustTime.call(this, 'dropOff', !!param.dropOffTime, dropOffMinIdx);
                }

                this.pickUp.time.options = this.defaultTimeOptions.slice(pickUpMinIdx, pickUpMaxIdx);
                this.dropOff.time.options = this.defaultTimeOptions.slice(dropOffMinIdx);
            }

            function getPickUpMinIdx(pickUpDateTime) {
                const now = moment();
                const pickUpIsToday = pickUpDateTime.isSame(now, 'day');
                let pickUpMinIdx;

                if (pickUpIsToday) {
                    pickUpMinIdx = getTimeOptionIndexByTime(this.defaultTimeOptions, now.hour() * 60 + now.minute());
                } else if (!pickUpIsToday || !pickUpDateTime.isValid()) {
                    pickUpMinIdx = undefined;
                }

                return pickUpMinIdx;
            }


            function getTimeOptionIndexByTime(options, timeValue) {
                for (let i = 0; i < options.length; i++) {
                    if (options[i].value >= timeValue) {
                        return i;
                    }
                }
            }
}



// WEBPACK FOOTER //
// ./src/app/modules/cars/services/carsRequestDataFactory.js